<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p22" title="22">
<h2 class="recipetitle" id="apricot_stuffed_french_toast">Apricot-Stuffed French Toast</h2>
<p class="recipetime"><span class="yield_black">6 servings (2 slices each)</span> <span class="separater">|</span> Prep Time: 20 Minutes <span class="separater">|</span> Start to Finish: 1 Hour 15 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">1</span> loaf (8 oz) or ½ loaf (1-lb size) day-old French bread</li>
<li class="list"><span class="qty1">3</span> oz (from 8-oz package) cream cheese, softened</li>
<li class="list"><span class="qty1">3</span> tablespoons apricot preserves</li>
<li class="list"><span class="qty1">¼</span> teaspoon grated lemon peel</li>
<li class="list"><span class="qty1">3</span> eggs</li>
<li class="list"><span class="qty1">¾</span> cup half-and-half or milk</li>
<li class="list"><span class="qty1">2</span> tablespoons granulated sugar</li>
<li class="list"><span class="qty1">1</span> teaspoon vanilla</li>
<li class="list"><span class="qty1">⅛</span> teaspoon salt</li>
<li class="list"><span class="qty1">⅛</span> teaspoon ground nutmeg, if desired</li>
<li class="list"><span class="qty1">2</span> tablespoons butter, softened</li>
<li class="list"><span class="qty1"></span> Powdered sugar, if desired</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Spray 13x9-inch pan with cooking spray. Cut bread crosswise into 12 (1-inch) slices. Cut horizontal slit in side of each bread slice, cutting to but not through other side.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In medium bowl, beat cream cheese, preserves and lemon peel with electric mixer on medium speed about 1 minute or until well mixed. Spread about 2 teaspoons cream cheese mixture inside slit in each bread slice. Place stuffed bread slices in pan.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> In medium bowl, beat eggs, half-and-half, granulated sugar, vanilla, salt and nutmeg with fork or whisk until well mixed. Pour egg mixture over bread slices; turn slices carefully to coat.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> Cover; refrigerate at least 30 minutes but no longer than 24 hours. Or to freeze, wrap pan tightly. Freeze up to 3 months. Thaw in refrigerator overnight.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> Heat oven to 425°F. Uncover or unwrap pan. Bake 20 to 25 minutes or until golden brown. Top with butter and sprinkle with powered sugar.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 310; Total Fat 16g (Saturated Fat 8g, Trans Fat 1g); Cholesterol 145mg; Sodium 380mg; Total Carbohydrate 32g (Dietary Fiber 1g); Protein 9g <span class="nutr_bold">Exchanges:</span> 1 Starch, 1 Other Carbohydrate, 1 High-Fat Meat, 1½ Fat <span class="nutr_bold">Carbohydrate Choices:</span> 2</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p022.vue?2baa5e24